<template>
    <div>
        <el-card class="box-card" shadow="never">
            <el-row :gutter="10">
                <div class="search-title">
                    仪表用量详情
                </div>
                <div class="search-input-item">
                    <el-date-picker
                    v-model="query.dataRange"
                    type="daterange"
                    align="right"
                    size="small"
                    style="width: 410px"
                    value-format="yyyy-MM-dd"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
        
                <div class="search-button-tools">
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.listPageUseData'" :loading="tableLoading" @click="doSearch">查询</el-button>
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.exportUseData'" v-debounce @click="doExport">导出</el-button>
                    <el-button size="small" @click="doClose">关闭</el-button>
                </div>
                <el-table  
                :data="tableData"
                row-key="id" 
                border
                v-loading="tableLoading"
                tooltip-effect="light"
                :stripe="true">
                    <el-table-column width="150" show-overflow-tooltip prop="payMeterNo" label="表号"></el-table-column>
                    <el-table-column width="150" show-overflow-tooltip prop="projectName" label="项目小区"></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip prop="floorName" label="楼栋"></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip prop="roomName" label="房间"></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip prop="roomCusName" label="业主名"></el-table-column>
                    <el-table-column width="150" prop="totalUse" label="累计使用度数/吨数" align="right"></el-table-column>
                    <el-table-column width="180" prop="totalAmount" label="累计使用金额" align="right"></el-table-column>
                    <el-table-column width="180" prop="remainUse" label="剩余度数/吨数" align="right"></el-table-column>
                    <el-table-column width="150" prop="remainUse" label="剩余金额" align="right"></el-table-column>
                    <el-table-column width="180" prop="readDate" label="读表时间"></el-table-column>
                    <el-table-column width="180" prop="accualDate" label="快照月份"></el-table-column>
                    <el-table-column width="180" prop="createDate" label="创建时间"></el-table-column>
                </el-table>
                <simple-pagination @search="doSearch" />
            </el-row>
        </el-card>
    </div>
</template>

<script>
import '@/assets/scss/common.scss';
import mixin from '@/mixin/index';
import dlg from '@/mixin/dlg';
export default {
    name: "UseDataDetailTable",
    mixins: [mixin, dlg],
    props: {
        payMeterNo: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            queryListUrl: 'meter/web/snapshot/listPageMeterUseDataForDayByPayMeterNo',
        }
    },
    methods: {
        doSearch() {
            this.getList();
        },
        doExport() {
            const title = "仪表用量详情";
			const url = 'meter/web/snapshot/exportMeterUseDataForDayByPayMeterNo';
			this._export(title, url);
        },
    },
    mounted() {
        if(this.payMeterNo) {
            this.query.payMeterNo = this.payMeterNo;
            this.doSearch();
        }
    }
}
</script>